var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.1719 6.87207C21.9237 6.87207 19.6753 7.72792 17.9638 9.43945L9.43944 17.964C8.83789 18.5653 8.83789 19.5404 9.43944 20.1419C9.74004 20.4427 10.1343 20.5931 10.5283 20.5931C10.9226 20.5931 11.3167 20.4427 11.6174 20.1419L20.1418 11.6176C21.253 10.5064 22.7126 9.95095 24.1719 9.95095C25.6315 9.95095 27.0911 10.5064 28.2023 11.6176C30.4244 13.8399 30.4246 17.4559 28.2025 19.6782L19.678 28.2025C18.5667 29.3136 17.1072 29.8692 15.6476 29.8692C14.1881 29.8692 12.7285 29.3136 11.6174 28.2025C11.3167 27.9017 10.9226 27.7513 10.5283 27.7513C10.1343 27.7513 9.74004 27.9017 9.43944 28.2025C8.83789 28.8039 8.83789 29.7789 9.43944 30.3805C11.151 32.092 13.3996 32.9479 15.6478 32.9479C17.8962 32.9481 20.1443 32.0922 21.856 30.3807L30.3803 21.8562C33.8037 18.4329 33.8035 12.8629 30.3803 9.43945C28.6686 7.72792 26.4204 6.87207 24.1719 6.87207Z",
  fill: "url(#paint0_linear_1922_4356)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2999 0C15.0517 0 12.8034 0.855854 11.0917 2.56756L2.5674 11.0919C-0.855831 14.5151 -0.855831 20.0852 2.56758 23.5086C4.27911 25.2201 6.52735 26.076 8.77577 26.076C11.024 26.076 13.2724 25.2201 14.9839 23.5086L23.5083 14.9841C24.1098 14.3827 24.1098 13.4077 23.5083 12.8061C23.2077 12.5053 22.8134 12.3549 22.4194 12.3549C22.0253 12.3549 21.631 12.5053 21.3303 12.8061L12.806 21.3304C11.6949 22.4417 10.2353 22.9973 8.77577 22.9973C7.3162 22.9973 5.85664 22.4417 4.7454 21.3304C2.52328 19.1081 2.5231 15.4922 4.74522 13.2699L13.2699 4.74556C14.3808 3.6345 15.8405 3.07888 17.2999 3.07888C18.7596 3.07888 20.219 3.63432 21.3303 4.74556C21.631 5.04633 22.0253 5.19672 22.4194 5.19672C22.8134 5.19672 23.2077 5.04633 23.5083 4.74556C24.1098 4.14419 24.1098 3.16911 23.5083 2.56756C21.7967 0.855854 19.5483 0 17.2999 0Z",
  fill: "url(#paint1_linear_1922_4356)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1922_4356",
  x1: 8.98828,
  y1: 14.8252,
  x2: 33.5292,
  y2: 16.8282,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F639D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.463542,
  stopColor: "#AB2EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00C7FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1922_4356",
  x1: -8.03302e-9,
  y1: 7.95318,
  x2: 24.5408,
  y2: 9.95614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F639D1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.463542,
  stopColor: "#AB2EFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00C7FF"
})));

function SvgIconSpearly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpearly);
export default __webpack_public_path__ + "static/media/icon-spearly.c5f2f64212ad66e23b4611fd6662a08c.svg";
export { ForwardRef as ReactComponent };